export { default as ListOfPortals } from './hocs';
